import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  localstorageAuthorizationKey = 'last_known_authorization' as const;
  localstorageRefreshKey = 'refresh_token' as const;
  constructor(private http: HttpClient) {}

  refreshToken(): Observable<HttpResponse<any>> {
    return this.http.post('/api/Authorization/Refresh', null, {
      withCredentials: true,
      observe: 'response',
      responseType: 'json',
    });
  }

  setAdminKey(key: string) {
    if (key) {
      window.localStorage.setItem('adminKey', key);
    } else {
      this.clearAdminKey();
    }
  }

  clearAdminKey() {
    window.localStorage.removeItem('adminKey');
  }

  loadAuthorizationFromStorage(): string {
    return window.localStorage.getItem(this.localstorageAuthorizationKey);
  }

  logout() {
    window.localStorage.removeItem(this.localstorageAuthorizationKey);
    window.localStorage.removeItem(this.localstorageRefreshKey);
  }
}
